import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppMaterialModule } from 'src/app/app-material.module';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './../shared/components/header/header.component';
import { BaseComponent } from './base.component';
import { environment } from '@environment/environment';

@NgModule({
  declarations: [BaseComponent, HeaderComponent],
  imports: [CommonModule, RouterModule, TranslateModule, AppMaterialModule, SharedModule],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_LOCALE, useValue: environment.defaultLanguage },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: environment.defaultDateInput,
        },
        display: {
          dateInput: environment.defaultDateInput,
          monthYearLabel: 'MMMM YYYY',
          dateA11yLabel: environment.defaultDateInput,
          monthYearA11yLabel: 'MMMM YYYY'
        },
      }
    }]
})
export class BaseModule { }
